var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$branding.data.code === 'default')?_c('div',{staticClass:"cancel-account-note"},[_c('v-icon',{attrs:{"size":"20","color":"text lighten-1"}},[_vm._v("$vuetify.icons.infotip_hot")]),_c('span',{staticClass:"text--text text--lighten-1 w-caption"},[_vm._t("cancelText")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }